<template>
  <div class="mb-4">
    <div class="rounded-lg overflow-hidden shadow-lg p-4 md:p-0">
      <div class="grid grid-cols-2 md:grid-cols-4">
        <div>
          <img src="../../assets/decosummit-event.png" class="object-cover object-center" />
        </div>
        <div class="pt-4">
          <h4 class="text-xs font-bold text-gray-600 uppercase mb-3">
            {{ $t('dashboard.events.table.h1') }}
          </h4>
          <div class="py-5">
            {{ eventCode.description }}
          </div>
        </div>
        <div class="pt-4">
          <h4 class="text-xs font-bold text-gray-600 uppercase mb-3">
            {{ $t('dashboard.events.table.h2') }}
          </h4>
          <div class="bg-gray-100 font-semibold text-sm w-9/12 mx-auto py-5">
            {{ eventCode.discount_code }}
          </div>
        </div>
        <div class="pt-4">
          <h4 class="text-xs font-bold text-gray-600 uppercase mb-3">
            {{ $t('dashboard.events.table.h3') }}
          </h4>
          <div
            class="font-bold text-sm py-5"
            :class="[eventCode.redeemed ? 'text-ricoma-green-100' : 'text-ricoma-red-100']"
          >
            <span v-if="eventCode.redeemed">REDEEMED</span>
            <a
              href="https://www.decosummit.com/register"
              target="_blank"
              class="underline text-ricoma-blue-300"
              v-if="!eventCode.redeemed"
              >CLAIM TICKET</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardEventRow',
  props: { eventCode: Object },
  computed: {},
  methods: {},
};
</script>
